export enum AllocationTypes {
  sales = 'SALES',
  purchases = 'PURCH',
}
